import { Drawer, IconButton, List, SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import MenuIcon from '@material-ui/icons/Menu';
import React, { lazy, useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import HomeIcon from 'components/Icons/HomeIcon';
import { AppContext } from 'context';
import { UserRole } from 'types';
import { fonts } from 'theme';
import ClipboardIcon from 'components/Icons/ClipboardIcon';
import FeatherIcon from 'components/Icons/FeatherIcon';
import MenuItemLink from './MenuItemLink';

export const drawerWidthOpened = '16.5rem';
export const drawerWidthOpenedSubMenu = '14rem';
export const drawerWidthClosed = 60;

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidthOpened,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidthOpened,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: drawerWidthClosed,
  },
  burgerMenuButton: {
    position: 'fixed',
    top: '10px',
    zIndex: theme.zIndex.drawer + 1,
    padding: theme.spacing(0, 1),
  },
  downloadLink: {
    textDecoration: 'none',
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: 12,
    fontWeight: 500,
    padding: '5px 15px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  list: {
    '& > *': {
      width: `calc(${drawerWidthOpened}-1px)`,
    },
    marginTop: '80px',
    paddingBottom: '20px',
  },
  mainMenu: {
    minHeight: 'calc(100vh - 180px)',
  },
}));

interface Props {
  open: boolean;
  setOpen: any;
}

const AdminMenuLinks = lazy(() => import('components/Menu/AdminMenuLinks'));
const SortingCentersMenuLinks = lazy(() => import('components/Menu/SortingCentersMenuLinks'));

const Menu: React.FC<Props> = ({ open, setOpen }) => {
  const classes = useStyles();
  const context = useContext(AppContext);

  const { t } = useTranslation();
  return (
    <>
      <div className={classes.burgerMenuButton}>
        <IconButton
          onClick={() => {
            setOpen(!open);
          }}
        >
          <MenuIcon />
        </IconButton>
      </div>
      <Drawer
        variant="permanent"
        anchor="left"
        className={`${classes.drawer} ${open ? classes.drawerOpen : classes.drawerClose}`}
        classes={{
          paper: open ? classes.drawerOpen : classes.drawerClose,
        }}
      >
        <List className={classes.list}>
          <div className={classes.mainMenu}>
            <MenuItemLink
              button
              exact
              sidebarIsOpen={open}
              leftIcon={<SvgIcon component={HomeIcon} />}
              primaryText={t('menuItem.home')}
              to="/"
              urlMatch={['/']}
            />

            {context.getRoles()?.includes(UserRole.ROLE_SUPER_ADMIN) ? (
              <AdminMenuLinks sidebarIsOpen={open} />
            ) : (
              <SortingCentersMenuLinks sidebarIsOpen={open} />
            )}
          </div>

          <Link to="/politique-de-confidentialite.pdf" target="_blank" download className={classes.downloadLink}>
            <FeatherIcon style={{ marginRight: 10 }} /> {t('privacyPolicy')}
          </Link>
          <Link to="/cgu.pdf" target="_blank" download className={classes.downloadLink}>
            <ClipboardIcon style={{ marginRight: 12 }} /> {t('termsOfUse')}
          </Link>
        </List>
      </Drawer>
    </>
  );
};
export default Menu;
